import {Editor} from 'tinymce';

import {findMergeTags} from './utils';
import {getMergeTagsEditable, getMergeTagsPrefix, getMergeTagsSuffix} from '../api/Options';
import * as MergeTag from './MergeTag';

const setup = (editor: Editor) => {
  const tinymce = (window as any).tinymce;
  const prefix = getMergeTagsPrefix(editor);
  const suffix = getMergeTagsSuffix(editor);
  const editable = getMergeTagsEditable(editor);

  editor.on('PreInit', () => {
    /*
     * Serialize nodes with `pm-merge-tag` attribute.
     * Show them in tinymce editor as formatted, but remove them to make the sourcecode clean.
     */
    const textNodeFilter = (nodes: any, mode: string, parserArgs: any): void => {
      if (!nodes?.length) {
        return;
      }

      if (parserArgs?.insert && parserArgs?.isRootContent) {
        /*
         * Handle on editor load; initial insert.
         */
        nodes.forEach((node: any, index: number) => {
          const mergeTags = findMergeTags(node.value, prefix, suffix);

          if (!mergeTags) {
            return;
          }
          const parent = node.parent;

          mergeTags.forEach((mergeTag: any) => {
            let element;
            if (mergeTag.isMergeTag) {
              let value = mergeTag.text;
              value = value.replace(prefix, '');
              value = value.replace(suffix, '');

              element = MergeTag.create(value, prefix, suffix, editable);
            } else {
              element = tinymce.html.Node.create("#text");
              element.value = mergeTag.text;
            }

            parent.append(element);
          });
          node.remove(); // if merge tags exists, remove node element.
        });
      }

      if (parserArgs?.data?.paste) {
        /*
         * Handle on paste.
         * From paste text to MergeTag
         */
        const firstNode = nodes[0];
        let value = firstNode.value.trim();

        if (value.startsWith(prefix) && value.endsWith(suffix)) {
          value = value.replace(prefix, '');
          value = value.replace(suffix, '');

          const mergeTag = MergeTag.create(value, prefix, suffix, editable);
          firstNode.replace(mergeTag);
        }
      }
    };

    editor.parser.addNodeFilter('#text', textNodeFilter);

    editor.serializer.addAttributeFilter('data-pm-merge-tag,data-pm-merge-tag-affix', (nodes: any) => {
      for (let index = 0, length = nodes.length; index < length; index++) {
        const node = nodes[index];
        node.unwrap(); /* unwrap: removes the node but keeps the children */
      }
    });
  });
}

export {
  setup,
}
